import { IAppState } from 'src/interface/IAppState';
import { IitemComment } from 'src/interface/IDetailState';

export const listCommentDetail = (appState: IAppState): Array<IitemComment> =>
  appState.detailState.listComment;
export const limitListCommentDetail = (appState: IAppState): number =>
  appState.detailState.limitListComment;
